import { company_name } from "@/i18n/variables";

const not_available_card = {
	button: `Ga naar ${company_name} Announcements`,
	title: "NIET BESCHIKBAAR",
};

export default not_available_card;
